import {
  AlignHorizontalCenterRounded,
  AlignHorizontalLeftRounded,
  AlignHorizontalRightRounded,
  AlignVerticalBottomRounded,
  AlignVerticalCenterRounded,
  AlignVerticalTopRounded,
  ArrowBackRounded,
  ArrowDownwardRounded,
  ArrowForwardRounded,
  ArrowUpwardRounded,
} from "@mui/icons-material";
import * as React from "react";
import { TXGUISection } from "../../interfaces/gui/fields.interfaces";
import { ELEMENTS_GUI_FIELDS } from "../elements/elements.settings";

export const CONTAINERS_GUI_FIELDS: TXGUISection = {
  Général: [
    {
      type: "toggle_option",
      name: "containerMode",
      label: "type de Container",
      options: [
        { value: "NONE", label: "Aucun" },
        { value: "CENTER", label: "Centrer" },
        { value: "FILL", label: "Large" },
      ],
      defaultValue: "NONE",
    },
    { type: "sizing", name: "gap", label: "Espacement", units: ["px", "em"] },
  ],
  Placements: [
    {
      type: "toggle_option",
      name: "direction",
      label: "Direction (Axe Princ.)",
      options: [
        {
          value: "column",
          label: "Du Haut vers le bas",
          icon: <ArrowDownwardRounded />,
        },
        {
          value: "row",
          label: "De la Gauche vers la droite",
          icon: <ArrowForwardRounded />,
        },
        {
          value: "row-reverse",
          label: "De la Droite vers la gauche",
          icon: <ArrowBackRounded />,
        },
        {
          value: "column-reverse",
          label: "Du Bas vers le haut",
          icon: <ArrowUpwardRounded />,
        },
      ],
      defaultValue: "column",
    },
    {
      type: "toggle_option",
      name: "justifyContent",
      label: "Alignement Axe Princ.",
      options: [
        {
          value: "flex-start",
          label: "Haut",
          icon: <AlignHorizontalLeftRounded />,
        },
        {
          value: "center",
          label: "Centre",
          icon: <AlignHorizontalCenterRounded />,
        },
        {
          value: "flex-end",
          label: "Bas",
          icon: <AlignHorizontalRightRounded />,
        },
        {
          value: "space-between",
          label: "S-B",
        },
      ],

      // options: [
      //   { value: "flex-start", label: "Début" },
      //   { value: "center", label: "Centre" },
      //   { value: "flex-end", label: "Fin" },
      //   { value: "space-between", label: "Espace au milieu" },
      //   { value: "space-around", label: "Espace distribué" },
      // ],
    },
    {
      type: "toggle_option",
      name: "alignItems",
      label: "Alignement Axe Secon.",
      options: [
        {
          value: "flex-start",
          label: "Haut",
          icon: <AlignVerticalTopRounded />,
        },
        {
          value: "center",
          label: "Centre",
          icon: <AlignVerticalCenterRounded />,
        },
        {
          value: "flex-end",
          label: "Bas",
          icon: <AlignVerticalBottomRounded />,
        },
      ],
      defaultValue: "flex-start",
    },
  ],
  Grille: [
    {
      type: "toggle_option",
      name: "colSpan",
      label: "Colone Occupée (Hor)",
      options: [
        { value: 1, label: "1" },
        { value: 2, label: "2" },
        { value: 3, label: "3" },
        { value: 4, label: "4" },
        { value: 5, label: "5" },
        { value: 6, label: "6" },
        { value: 7, label: "7" },
        { value: 8, label: "8" },
      ],
      defaultValue: 1,
    },
    {
      type: "number",
      name: "rowSpan",
      label: "Ligne Occupée (Vert)",
      defaultValue: 1,
    },
  ],
  ...ELEMENTS_GUI_FIELDS,
};
